
export default class PageWrapper<T> {
    public totalPages: number;
    public totalElements: number;
    public pageNumber: number;
    public pageSize: number;
    public content: Array<T>;
    constructor({
        totalPages = 0,
        totalElements = 0,
        pageNumber = 1,
        pageSize = 20,
        content = [],
    }={}) {
        this.totalPages =totalPages ;
        this.totalElements =totalElements ;
        this.pageNumber = pageNumber;
        this.pageSize = pageSize;
        this.content = content;
    }
}